import { IconResolver, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Adds an SVG icon resolver to the MatIconRegistry based on the provided configuration.
 *
 * This is handy if you need to load specific icons from a 3rd party source.
 */
export function addIconResolver(
  config: { basePath: string; icons: { sourcesUrl: string; prefixPath: string } },
  iconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer
): void {
  const sourcesUrl = config.basePath + config.icons.sourcesUrl;

  const resolver: IconResolver = name => {
    if (name.startsWith(config.icons.prefixPath)) {
      const sanitizedIconName = name.replace(config.icons.prefixPath, '');
      return sanitizer.bypassSecurityTrustResourceUrl(`${sourcesUrl}/${sanitizedIconName}.svg`);
    }
    return null;
  };

  iconRegistry.addSvgIconResolver(resolver);
}
